export const MenuItems = [
  {
    id: "1",
    name: "Home",
    href: "/",
  },
{
  id: "2",
  name: "About Us",
  href: "#",

  submenu: [
    { id: "2-1", name: "Overview", href: "#" },
    { id: "2-2", name: "Mission & Vision", href: "#" },
    { id: "2-3", name: "Leadership", href: "#" },
    { id: "2-4", name: "Certifications", href: "#" },
    { id: "2-5", name: "Partnerships", href: "#" },
    { id: "2-6", name: "Clients", href: "#" },
    { id: "2-7", name: "CSR Policy", href: "#" },
    { id: "2-8", name: "Infrastructure", href: "#" },
   ,
  ],
},
 {
  id: "3",
  name: "System",
  href: "#",

  submenu: [
    { id: "3-1", name: "Ash Handling Systems", href: "#" },
    { id: "3-2", name: "Bottom Ash Transporting System", href: "#" },
    { id: "3-3", name: "Coarse Ash Transporting System", href: "#" },
    { id: "3-4", name: "Fly Ash Transporting System", href: "#" },
    { id: "3-5", name: "Ash Slurry Disposal System", href: "#" },
    { id: "3-6", name: "Coal Gasifier Ash Transporting System", href: "#" },
    { id: "3-7", name: "Ash Water Recirculation Systems", href: "#" },
    { id: "3-8", name: "Coal Mill Reject Handling Systems", href: "#" },
    { id: "3-9", name: "Pressure Conveying System", href: "#" },
    { id: "3-10", name: "Belt Conveying System", href: "#" },
  ],
},

{
  id: "4",
  name: "Services",
  href: "#",

  submenu: [
    { id: "4-1", name: "Operation & Maintainance", href: "#" },
    { id: "4-2", name: "Renovation and System Improvement", href: "#" },
  ],
},


{
  id: "5",
  name: "Products & Parts",
  href: "#",

  submenu: [
    { id: "5-1", name: "Ash Handling Equipments", href: "#" },
    { id: "5-2", name: "Slurry Pump Replacement", href: "#" },
  ],
},
  {
    id: "6",
    name: "Infrastructure",
    href: "#",
 
  },

   {
    id: "7",
    name: "career",
    href: "#",      
  },

 {
    id: "8",
    name: "contact us",
    href: "#",
 
  },
];

export const MenuItems2 = [
  // {
  //   id: "4",
  //   name: "Clients",
  //   href: "/clients",

  //   submenu: [{ id: "4-1", name: "Certificates", href: "/certificate" }],
  // },

  {
    id: "4",
    name: "Clients",
    href: "/clients",
  },
  {
    id: "5",
    name: "Certificates",
    href: "/certificate",
  },
  // {
  //   id: "5",
  //   name: "Media & PR",
  //   href: "https://www.emergeglass.in/media-pr.pdf",

  //   submenu: [
  //     { id: "5-1", name: "Events", href: "/coming-soon" },
  //     { id: "5-2", name: "Gallery", href: "/coming-soon" },
  //   ],
  // },
  {
    id: "6",
    name: "Contact Us",
    href: "/contact-us",

    submenu: [{ id: "6-1", name: "Career", href: "/career", target: "" }],
  },
];
